import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import ProtectedRoutes from './Routes/Protected'
import Login from './Pages/Login'
import { Provider } from 'react-redux';
import { store, persistor } from './Redux/store';
import { PersistGate } from 'redux-persist/integration/react'

function App(props) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Switch>
            <Route exact path='/login' component={Login} />
            <ProtectedRoutes />
            <Route render={() => (
              <Redirect to='/login' />
            )} />
          </Switch>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
